// @generated by TypeGen from LogbookModel/Settings/ShipSettings.swift - DO NOT EDIT

import type { INavigationThresholds } from "../../LogbookFoundation/Navigation"
import type { IEditPermissivenessLevel } from "../EditPermissiveness"
import type { ILogLighting, ISailingLightsMode } from "../Lighting"
import type { IAnchorWatchSettings } from "../Status/MonitorStatus"

export interface IShipSettings {
  thresholds: INavigationThresholds;
  timezone?: number;
  unit: IUnitSetting;
  logOffset?: number;
  keepManualRpm?: boolean;
  lightsReminder?: boolean;
  lightsReminderSettings?: IShipLightsReminderSettings;
  anchorWatchSettings?: IAnchorWatchSettings;
  editPermissiveness?: IEditPermissivenessLevel;
}

export interface IShipLightsReminderSettings {
  sailingLights?: ISailingLightsMode;
  disabledSignals?: ILogLighting[];
  lead?: ILightsReminderLead;
}

export interface IUnitSetting {
  currency: string;
  current: IUnitCurrent;
  distance: IUnitDistance;
  length: IUnitLength;
  power: IUnitPower;
  pressure: IUnitPressure;
  speed: IUnitSpeed;
  surface: IUnitSurface;
  temperature: IUnitTemperature;
  volume: IUnitVolume;
  weight: IUnitWeight;
  wind: IUnitWind;
}

export enum ILightsReminderLead {
  official,
  civil,
}

export enum IUnitCurrency {
  eur = "eur",
  usd = "usd",
  gbp = "gbp",
  jpy = "jpy",
  aud = "aud",
  nzd = "nzd",
  chf = "chf",
  sek = "sek",
  nok = "nok",
  dkk = "dkk",
}

export enum IUnitCurrent {
  kn = "kn",
  kmh = "kmh",
}

export enum IUnitDistance {
  nm = "nm",
  miles = "miles",
  km = "km",
}

export enum IUnitLength {
  m = "m",
  cm = "cm",
  ft = "ft",
  inch = "inch",
  yard = "yard",
}

export enum IUnitPower {
  kw = "kw",
  hp = "hp",
}

export enum IUnitPressure {
  hpa = "hPa",
  bar = "bar",
  psi = "psi",
}

export enum IUnitSpeed {
  kn = "kn",
  kmh = "kmh",
  mph = "mph",
}

export enum IUnitSurface {
  m2 = "m2",
  sqft = "sqft",
  sqyd = "sqyd",
}

export enum IUnitTemperature {
  celsius = "celsius",
  fahrenheit = "fahrenheit",
}

export enum IUnitVolume {
  l = "l",
  gal = "gal",
  m3 = "m3",
  cuft = "cuft",
}

export enum IUnitWeight {
  kg = "kg",
  lb = "lb",
  tons = "tons",
}

export enum IUnitWind {
  kn = "kn",
  mps = "mps",
  kmh = "kmh",
}
